import React from 'react';
import { FaBell, FaTrash } from 'react-icons/fa';

const AdminNotificationsTab = ({ notifications, handleDeleteNotification, setShowSendNotification }) => (
  <div className="space-y-6">
    <div className="flex justify-between items-center">
      <h2 className="text-xl font-bold text-white">Notifications</h2>
      <button
        onClick={() => setShowSendNotification(true)}
        className="px-4 py-2 bg-gradient-to-r from-[#D4AF37] to-[#FFD700] text-[#0A1929] font-bold rounded-lg flex items-center space-x-2"
        data-testid="send-notification-btn"
      >
        <FaBell /> <span>Send Notification</span>
      </button>
    </div>

    <div className="space-y-4">
      {notifications.map((notif) => (
        <div key={notif.id} className={`bg-gradient-to-br from-[#1A2942] to-[#1E3A5F] rounded-xl p-4 border ${
          notif.notification_type === 'warning' ? 'border-yellow-500' :
          notif.notification_type === 'success' ? 'border-green-500' :
          notif.notification_type === 'announcement' ? 'border-purple-500' : 'border-[#2D5A8F]'
        }`}>
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <div className="flex items-center space-x-2 mb-2">
                <span className={`px-2 py-1 rounded text-xs ${
                  notif.notification_type === 'warning' ? 'bg-yellow-500/20 text-yellow-400' :
                  notif.notification_type === 'success' ? 'bg-green-500/20 text-green-400' :
                  notif.notification_type === 'announcement' ? 'bg-purple-500/20 text-purple-400' : 'bg-blue-500/20 text-blue-400'
                }`}>
                  {notif.notification_type}
                </span>
                <span className="text-gray-500 text-xs">To: {notif.target_roles?.join(', ')}</span>
              </div>
              <h3 className="text-white font-bold">{notif.title}</h3>
              <p className="text-gray-300 text-sm mt-1">{notif.message}</p>
              <p className="text-gray-500 text-xs mt-2">Sent by {notif.sent_by_name} • {new Date(notif.created_at).toLocaleString()}</p>
            </div>
            <button onClick={() => handleDeleteNotification(notif.id)} className="text-red-400 hover:text-red-300 ml-4">
              <FaTrash />
            </button>
          </div>
        </div>
      ))}
      {notifications.length === 0 && (
        <p className="text-gray-400 text-center py-8">No notifications sent yet</p>
      )}
    </div>
  </div>
);

export default AdminNotificationsTab;
